import { environment } from '../../environments/environment';
import { AppUrlConstant } from './app-url';

export class WebSocketApiUrl {
    public static readonly WEB_SOCKET_SERVER_URL = `${environment.webSocketApiUrl}${AppUrlConstant.URL_SEPARATOR}`;

    public static readonly WEB_SOCKET_MAP_API = `${this.WEB_SOCKET_SERVER_URL}${AppUrlConstant.WEB_SOCKET}`;
}
